import React, { useState } from 'react'
import PrivateRoute from '../../components/PrivateRoute'
import AdminRoute from '../../components/AdminRoute'
import { useNavigate } from 'react-router-dom'

import {
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
  Alert,
  LinearProgress,
  Box
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux'
import { addSong } from '../../actions/songActions'

const NewSong = () => {
  const [formData, setFormData] = useState({
    title: '',
    body: '',
    link: ''
  })
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, error } = useSelector(state => state.songState)

  const submitHandler = e => {
    e.preventDefault()
    dispatch(addSong(formData.title, formData.body, formData.link, navigate))
  }

  const changeField = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  return (
    <PrivateRoute>
      <AdminRoute>
        <Card sx={{ maxWidth: 650, mt: 5, mx: 'auto' }}>
          {loading && <LinearProgress />}
          <CardContent sx={{ p: 3 }}>
            <Typography sx={{ mb: 2 }} variant='h6'>Add Song</Typography>
            {error && <Alert severity='error'>{error}</Alert>}
            <form onSubmit={submitHandler}>
              <TextField
                label='Title'
                fullWidth
                sx={{ my: 2 }}
                name='title'
                value={formData.title}
                onChange={changeField}
              />
              <TextField
                label='External Link (optional)'
                fullWidth
                sx={{ my: 2 }}
                value={formData.link}
                onChange={changeField}
                name='link'
              />
              <TextField
                label='Body'
                fullWidth
                sx={{ my: 2 }}
                multiline
                maxRows={40}
                name='body'
                value={formData.body}
                onChange={changeField}
              />
              <Button variant='contained' type='submit' fullWidth sx={{ mt: 1 }}>Submit</Button>
            </form>
          </CardContent>
        </Card>
      </AdminRoute>
    </PrivateRoute>
  )
}

export default NewSong